<div
  id="detail"
  class="page-layout blank"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    <div
      class="name"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      <button mat-icon-button [routerLink]="'/exchange/sharemailbox'">
        <mat-icon>arrow_back</mat-icon>
      </button>
      {{ selectedShairemailbox?.title }}
    </div>
  </div>
  <!-- / HEADER -->
  <div class="content" fxLayout="row wrap">
    <!-- CONTENT CARD -->
    <div class="content-card" fxFill>
      @if (isLoading) {
        <mat-progress-bar
          color="accent"
          mode="indeterminate"
          class="mat-progress-bar"></mat-progress-bar>
      }
      @if (!isLoading && isLoadingUsers && !isErrorGetSharemailbox) {
        <div class="message-box accent loading-user">
          <mat-label>{{
            'SHAREDMAILBOX-DETAIL.LOADINGUSERS' | translate
          }}</mat-label>
        </div>
      }
      @if (hasError && !isErrorGetSharemailbox) {
        <div class="message-box error loading-user">
          {{ 'SHAREDMAILBOX-DETAIL.ERRORLOADINGUSERS' | translate }}
        </div>
      }
      <!-- CONTENT -->
      @if (!isLoading && !isErrorGetSharemailbox) {
        <div class="general-content">
          <div
            class="user-interface"
            fxLayout="column"
            fxFlex="30"
            fxFlex.md="30"
            fxFlex.sm="50"
            fxFlex.xs="100"
            fxLayout="column">
            <mat-card class="mat-card profile-card">
              <h2>{{ 'SHAREDMAILBOX-DETAIL.TITLE' | translate }}</h2>
              <div class="profile-picture" fxLayoutAlign="center center">
                <img
                  class="profile-image"
                  src="assets/images/exchange/exchange_sharemailbox.png"
                  [@animate]="{
                    value: '*',
                    params: { delay: '50ms', scale: '0.2' },
                  }"
                  alt="Logo exchange sharemailbox" />
              </div>
              <mat-list role="list">
                <mat-list-item>
                  <mat-icon matListItemIcon>book</mat-icon>
                  <h4 matListItemTitle>{{ selectedShairemailbox.title }}</h4>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>mail</mat-icon>
                  <h4 matListItemTitle>
                    {{ selectedShairemailbox.mailBoxAddress }}
                  </h4>
                </mat-list-item>
              </mat-list>
            </mat-card>
          </div>
          <div
            class="info-interface"
            ffxLayout="column"
            fxFlex="70"
            fxFlex.md="70"
            fxFlex.sm="50"
            fxFlex.xs="100"
            fxLayout="column">
            <mat-card class="security-card">
              <h2>{{ 'SHAREDMAILBOX-DETAIL.MODIFY' | translate }}</h2>
              <br />
              <form fxLayout="column" [formGroup]="sharemailboxform">
                <div fxFlex="1 0 auto" fxLayout="column">
                  <div fxFlex="2 0 auto" fxLayout="column">
                    <mat-form-field appearance="outline" fxFlex="100">
                      <mat-label>{{
                        'SHAREDMAILBOX-DETAIL-FORM.FORM.DISPLAYNAME' | translate
                      }}</mat-label>
                      <input matInput formControlName="displayName" />
                    </mat-form-field>
                  </div>
                </div>
              </form>
              <mat-slide-toggle
                class="form-text"
                [checked]="displayInGal"
                [(ngModel)]="displayInGal"
                [disabled]="isDisabled">
                {{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.DISPLAYINGAL' | translate }}
              </mat-slide-toggle>
              <div fxLayout="row">
                <div fxLayout="column" class="mr-16">
                  <h2>
                    {{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-RES-TITLE'
                        | translate
                    }}
                  </h2>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center">
                  <mat-icon
                    class="mat-icon-custom"
                    matTooltipClass="tooltip"
                    matTooltip="{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-RES-TOOLTIP'
                        | translate
                    }}"
                    >help</mat-icon
                  >
                </div>
              </div>
              <div fxLayout="row" class="checkbox-container">
                <div fxLayout="column" fxFlex="50" class="checkboxes">
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="ajout_Directeur"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-DIR' | translate
                    }}</mat-checkbox
                  >
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="ajout_ConseilDir"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-CONSDIR' | translate
                    }}</mat-checkbox
                  >
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="ajout_secDir"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-SECDIR' | translate
                    }}</mat-checkbox
                  >
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="ajout_ITRes"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-RI' | translate
                    }}</mat-checkbox
                  >
                </div>
                <div fxLayout="column" fxFlex="50" class="checkboxes">
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="ajout_ITGest"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-GESTIT' | translate
                    }}</mat-checkbox
                  >
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="ajout_admin"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-ADMIN' | translate
                    }}</mat-checkbox
                  >
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="ajout_Tech"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-TECH' | translate
                    }}</mat-checkbox
                  >
                </div>
              </div>
              <div fxLayout="row" class="users-container">
                <div fxLayout="column" fxFlex="90" class="users-selected">
                  <mat-form-field
                    class="chip-list"
                    appearance="fill"
                    class="nom-access">
                    <mat-label>{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.NOM-ACCESS' | translate
                    }}</mat-label>
                    <mat-chip-grid
                      #gridUserSelection
                      aria-label="User selection"
                      class="mat-chip-list label-chips"
                      [disabled]="isDisabled">
                      @for (user of users; track user) {
                        <mat-chip-row
                          (removed)="remove(user)"
                          class="mat-chip mat-standard-chip label-chip background-selected">
                          {{ user.officialemail }}
                          <button matChipRemove class="removeBtn">
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip-row>
                      }
                    </mat-chip-grid>
                    <input [matChipInputFor]="gridUserSelection" hidden />
                  </mat-form-field>
                </div>
                <div
                  class="button-user-selected"
                  fxLayout="column"
                  fxDirection="end"
                  fxFlex="10"
                  fxLayoutAlign="center center">
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent"
                    class="add-nom-btn"
                    (click)="addUserForAccess()"
                    [disabled]="isLoadingUsers || isDisabled">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </div>
              <div class="form-text">
                {{
                  'SHAREDMAILBOX-DETAIL-FORM.FORM.NOM-ACCESS-DESC' | translate
                }}
              </div>
              <div fxLayout="row">
                <div fxLayout="column" class="mr-16">
                  <h2>
                    {{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-ACCESS-TITLE'
                        | translate
                    }}
                  </h2>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center">
                  <mat-icon
                    class="mat-icon-custom"
                    matTooltipClass="tooltip"
                    matTooltip="{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-ACCESS-TOOLTIP'
                        | translate
                    }}"
                    >help</mat-icon
                  >
                </div>
              </div>
              <div fxLayout="row" class="checkbox-container">
                <div fxLayout="column" fxFlex="50" class="checkboxes">
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="sendas_Directeur"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-DIR' | translate
                    }}</mat-checkbox
                  >
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="sendas_ConseilDir"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-CONSDIR' | translate
                    }}</mat-checkbox
                  >
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="sendas_secDir"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-SECDIR' | translate
                    }}</mat-checkbox
                  >
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="sendas_ITRes"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-RI' | translate
                    }}</mat-checkbox
                  >
                </div>
                <div fxLayout="column" fxFlex="50" class="checkboxes">
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="sendas_ITGest"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-GESTIT' | translate
                    }}</mat-checkbox
                  >
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="sendas_admin"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-ADMIN' | translate
                    }}</mat-checkbox
                  >
                  <mat-checkbox
                    class="form-text"
                    [(ngModel)]="sendas_Tech"
                    [disabled]="isDisabled"
                    >{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-TECH' | translate
                    }}</mat-checkbox
                  >
                </div>
              </div>
              <div fxLayout="row" class="users-container">
                <div fxLayout="column" fxFlex="90" class="users-selected">
                  <mat-form-field
                    class="chip-list"
                    appearance="fill"
                    class="nom-access">
                    <mat-label>{{
                      'SHAREDMAILBOX-DETAIL-FORM.FORM.NOM-ACCESS' | translate
                    }}</mat-label>
                    <mat-chip-grid
                      #gridUserSelection2
                      aria-label="User selection"
                      class="mat-chip-list label-chips"
                      [disabled]="isDisabled">
                      @for (user of sendAs_Nom; track user) {
                        <mat-chip-row
                          (removed)="removeSendas(user)"
                          class="mat-chip mat-standard-chip label-chip background-selected">
                          {{ user.officialemail }}
                          <button matChipRemove class="removeBtn">
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip-row>
                      }
                    </mat-chip-grid>
                    <input [matChipInputFor]="gridUserSelection2" hidden />
                  </mat-form-field>
                </div>
                <div
                  class="button-user-selected"
                  fxLayout="column"
                  fxDirection="end"
                  fxFlex="10"
                  fxLayoutAlign="center center">
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent"
                    class="add-nom-btn"
                    (click)="addUserForSendAs()"
                    [disabled]="isLoadingUsers || isDisabled">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </div>
              <div class="form-text">
                {{
                  'SHAREDMAILBOX-DETAIL-FORM.FORM.NOM-ACCESS-DESC' | translate
                }}
              </div>
              @if (isBusyUpdateSharemailbox) {
                <div
                  class="info-container"
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  <mat-progress-spinner
                    [color]="spinner.color"
                    [mode]="spinner.mode"
                    [value]="spinner.value"
                    [diameter]="spinner.diameter">
                  </mat-progress-spinner>
                </div>
              }
              @if (isErrorUpdateSharemailbox) {
                <div class="info-container">
                  <div class="message-box error">
                    <app-error-message
                      [error]="errorUpdateSharemailbox.error" />
                  </div>
                </div>
              }
              @if (issharemailboxUpdated) {
                <div class="info-container">
                  <div class="message-box success">
                    {{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.SUCCESS' | translate }}
                  </div>
                </div>
              }
              <div
                class="info-container"
                fxLayout="row"
                fxLayoutAlign="left center">
                @if (!isDisabled) {
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent"
                    class="button-space"
                    (click)="updateSharemailbox()"
                    [disabled]="sharemailboxform.invalid || isBusy">
                    {{ 'GENERAL.SAVE' | translate }}
                  </button>
                }
                <button
                  mat-raised-button
                  matStepperNext
                  type="button"
                  [routerLink]="'/exchange/sharemailbox'"
                  [disabled]="isBusy">
                  {{ 'GENERAL.RETURN' | translate }}
                </button>
              </div>
            </mat-card>
          </div>
        </div>
      }
      @if (isErrorGetSharemailbox) {
        <div>
          <div class="message-box error">
            <app-error-message [error]="errorGetSharemailbox.error" />
          </div>
        </div>
      }
      <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
  </div>
</div>
